var Equipe_List = {

    isMoving:false,
    mouseX:0,
    mouseY:0,
    currentRoll:null,
    timeoutRoll:0,

    init:function(){
        if(Config.isTouchDevice()){
            $(".rollover-container").addClass("mobile");
        }

        $('.membre-equipe').mousemove(function(event){
            Equipe_List.mouseX = event.pageX - $(this).offset().left;
            Equipe_List.mouseY = event.pageY - $(this).offset().top;
        });


        $(".membre-equipe").find(".illustration").mouseenter(function(){

            Equipe_List.currentRoll = $(this).find(".rollover-container");
            Debug.log("MOUSE ENTER EQUIPE : " + Equipe_List.currentRoll);

            clearTimeout(Equipe_List.timeoutRoll);
            Equipe_List.timeoutRoll = setTimeout(function(){
                Equipe_List.currentRoll.addClass("visible");

                Debug.log("ADD VISIBLE : " + Equipe_List.currentRoll.attr("class"));


            }, 80);


            Equipe_List.isMoving = true;
            Equipe_List.moveRollover();

        }).mouseleave(function(){
            Equipe_List.isMoving = false;
            clearTimeout(Equipe_List.timeoutRoll);
            /*$(this).find("img").css({width:$(this).find("img").attr("out_w"), height:$(this).find("img").attr("out_h")});*/
            $(this).find(".rollover-container").removeClass("visible");
        });
    },
    moveRollover:function(){

        Equipe_List.currentRoll.css({left:Equipe_List.mouseX, top:Equipe_List.mouseY});

        if(Equipe_List.isMoving == true){
            setTimeout(function(){
                Equipe_List.moveRollover();
            }, 40);
        }
    }
}

$(window).load(function(){
    if($(".membre-equipe").length){
        Equipe_List.init();
    }
})